import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import { useTranslation } from "next-i18next";

import {
  InformationCoreProps,
  InformationContainerLayout,
  iconStyle,
} from "@/features/common/components/informationContainer";
import { Heading } from "@/features/common/components/tailwind/Heading";

export const EmptyUser: React.FC<InformationCoreProps> = (props) => {
  const { message, position, flexDirection } = props;
  const { t, ready } = useTranslation("commmon");
  if (!ready) return null;
  return (
    <InformationContainerLayout
      position={position}
      flexDirection={flexDirection}
    >
      <AccountCircleOutlinedIcon style={iconStyle} />
      <Heading.H5>{message ?? t("common:information.emptyUser")}</Heading.H5>
    </InformationContainerLayout>
  );
};
